// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"285":"615c8ef0","385":"148f3673","885":"51979cde"}[chunkId] + ".js";
};